export const DASHBOARD_DESKTOP_MAX_WIDTH = '1500px';
